import actions from './actions';
import mutations from "./mutations";

const state = () => ({
    isCreateAdministratorPage: false,
    administrators: null,
    administratorDetails: null,
    administratorDetailsGroupsWithRoles: null,
    administratorDataForm: {
        email: '',
        phoneNumber: '',
        clock24Hours: false,
        locale: '',
        tenantId: '',
        timezone: '',
        dateFormat: '',
        enabled: false,
        locked: false
    },
    administratorPasswordForm: {
        plainPassword: '',
        repeatedPassword: ''
    },
    administratorFormInvalid: false,
    administratorFormTouched: false,
    availableRoles: [],
    selectedRoles: [],
    availableGroups: [],
    selectedGroups: [],
    administratorDataIsLoading: true,
    roles: null,
    groups: null,
    totalCount: 0,
    isBusy: false,
    tenants: []
});

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
